import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { Allergy } from '../../models/allergy';

const getAppointmentAllergyIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Allergy>) => memoize((
        appointmentId: Undefinable<number>
    ) => Object
        .keys(byId)
        .filter(x => appointmentId && appointmentId === byId[x]!.appointmentId)
        .map(x => +x)
        .sort((a, b) => a - b)
    )
);

const getAllergyHashSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Allergy>) => Object
        .keys(byId)
        .reduce(
            (prevValue, x) => {
                prevValue[x] = {
                    id: x,
                    date: byId[x]!.onsetDate
                } as PatientPortalDataMerge;
                return prevValue;
            },
            {} as Dictionary<PatientPortalDataMerge>
        )
);

export const selectors = {
    getAllergy: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<Allergy> => state.byId[id || ''],
    getAllergyHash: (
        state: State
    ): Dictionary<PatientPortalDataMerge> => getAllergyHashSelector(state),
    getAllergyIds: (
        state: State
    ): number[] => state.allIds,
    getAppointmentAllergyIds: (
        state: State,
        appointmentId: Undefinable<number>
    ): number[] => getAppointmentAllergyIdsSelector(state)(appointmentId),
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
